import ReactModal from "react-modal";
import "../../components/modal/ModalCss.scss";
import { useEffect, useMemo, useState } from "react";
import BasicButton from "components/button/BasicButton";
import { sendGet, sendPost, sendPut } from "api/restUtil";
import ReactDataTableDisplay from "components/DataTable/ReactDataTableDisplay";
import BranchAreaMgmtModal from "./BranchAreaMgmtModal";
import { modConfirm, saveConfirm } from "js/common";

/**
 * 지점 권역 팝업
 */
function BranchAreaListModal (props) {

	const { isOpen, onClose, initData, returnData, modalId } = props;
	// 권역 목록 데이터
	const [ dataList, setDataList ] = useState({})

	// 등록 팝업
	const [ isOpenAddModal, setIsOpenAddModal ] = useState(false);
	// 수정 팝업
	const [ isOpenModModal, setIsOpenModModal] = useState(false);
	// 수정 팝업 데이터 (지점ID, 권역NO)
	const [ modData, setModData] = useState({});

	
	// 권역 수정 팝업
	const modDataPop = (data) => {
		setModData({branchId: data.branchId, branchName: data.branchName, branchAreaNo: data.branchAreaNo});
		setIsOpenModModal(true);
	}

	//데이터 테이블 컬럼
	const columns = useMemo(() =>[
		{ header : "지점 ID", col : "branchId", cellWidth: "10", notView: true },
		{ header : "지점 명", col : "branchName", cellWidth: "10", notView: true },
		{ header : "권역 번호", col : "branchAreaNo", cellWidth: "100" },
		{ header : "활성화 여부", col : "activationYnStr", cellWidth : "50" },
		{ header : "관리", col: "branchId", cellWidth : "50", type : "modButton", onClick: modDataPop},
	], []);

	useEffect(() => {
		if(!isOpen) return;

		// const search = async () => {
		// 	searchList({});
		// };

		searchList({});


	}, [isOpen]);

	//목록 조회
	const searchList = async () => {

		let result = await sendGet("/api/mgmt/branch/" + initData.branchId + "/areas");
		if(result.respCode === "SUCCESS"){

			const dataList = result.data;
			dataList.forEach(data => {
				if(data.activationYn) {
					data.activationYnStr = "Y";
				} else {
					data.activationYnStr = "N";
				}
				data.branchName = initData.branchName;
				data.branchId = initData.branchId;
			});
			setDataList(dataList);
		}
	}

	// 권역 등록
	const regBranchArea = async (data) => {
		if(!saveConfirm()) return;

		let result = await sendPost("/api/mgmt/branch/" + data.branchId + "/areas", data);
		if(result.respCode === "SUCCESS") {
			alert("저장 되었습니다.");
			searchList();
			setIsOpenAddModal(false);
		}
	}
	// 권역 수정
	const modBranchArea = async (data) => {
		if(!modConfirm()) return;

		let result = await sendPut("/api/mgmt/branch/" + data.branchId + "/areas/" + data.branchAreaNo, data);
		if(result.respCode === "SUCCESS") {
			alert("저장 되었습니다.");
			searchList();
			setIsOpenModModal(false);
			setModData({});
		}
	}

	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel="지점 배달 권역"
			id={modalId}
		>
			<div className="me-modal">
				<div className="me-modal-container" style={{width: "600px", height: "500px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">지점 배달 권역</h4>
						</div>

						<div className="me-modal-body" style={{overflowY: "auto"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="body-area modal-form" id="branchAreaAddModModal">
								<table className="table-styled">
									<colgroup>
										<col width="150"/>
										<col width="*"/>
									</colgroup>
									<tbody>
										<tr>
											<th>지점 명</th>
											<td>{initData.branchName}</td>
										</tr>
										<tr>
											<th>지점 ID</th>
											<td>{initData.branchId}</td>
										</tr>
									</tbody>
								</table>
							</div>
							
							<div className="table-buttons mg-t-10 mg-b-10">
								<BasicButton
									label="추가"
									className="btn-add"
									onClick={() => setIsOpenAddModal(true)}
								/>
							</div>
							<ReactDataTableDisplay
								columns={columns}
								customDatas={dataList}
								hideCheckBox={true}
								percentageWidth={true}
								isPageNation={false}
							/>
							
						</div>

						<div className="me-modal-footer mg-t-10 mg-b-20">
							<div className="table-buttons" style={{justifyContent : "center"}}>
								{/* <BasicButton label="취소" className="btn-cancel" onClick={onClose} style={{width: "100%"}} /> */}
								<BasicButton label="닫기" className="btn-save" onClick={onClose} style={{width: "100%"}} />
							</div>
						</div>

					</div>

				</div>
			</div>

			{/* 권역 등록 */}
			<BranchAreaMgmtModal
				isOpen={isOpenAddModal}
				initData={{branchId : initData.branchId, branchName : initData.branchName }}
				onClose={()=> setIsOpenAddModal(false)}
				title="권역 등록"
				returnData={regBranchArea}
			/>
			{/* 권역 수정 */}
			<BranchAreaMgmtModal
				isOpen={isOpenModModal}
				initData={modData}
				onClose={()=> { setIsOpenModModal(false); setModData({}); }}
				title="권역 수정"
				returnData={modBranchArea}
			/>

		</ReactModal>
	);
}

export default BranchAreaListModal;
